import { useAppSelector } from '../store/hooks';
import UserHomePage from './home/UserHomePage';
import UnautheticatedHomePage from './UnautheticatedHomePage';

const HomePage = () => {
  const loggedIn = useAppSelector((state) => state.auth.loggedIn);

  return loggedIn ? <UserHomePage /> : <UnautheticatedHomePage />;
};

export default HomePage;
